import classNames from 'classnames';
import { Field, useField } from 'formik';
import React from 'react';

import { container, input, invalidInput } from './style.module.css';

interface InputProps {
	name: string;
	prompt?: string;
	type: string;
	placeholder?: string;
}

export const NewsletterFormInputText = (props: InputProps): JSX.Element => {
	const [field, meta, helpers] = useField(props);
	const errorOnThisField = meta.error && meta.touched;
	return (
		<div className={container}>
			<Field
				className={classNames(input, errorOnThisField && invalidInput)}
				type={props.type}
				name={props.name}
				placeholder={props.placeholder ?? ' '}
			/>
		</div>
	);
};
